"use client";
import classNames from "classnames";
import { useMemo } from "react";
import omit from "lodash/omit";

import AuthLogin from "@stadium/shared/src/components/header/auth/login-btn";
import { SpeakWithAnExpertCta } from "@stadium/shared/src/components/header/shared/contact-us";

import { useFlags, withSyncFeatureFlag } from "@stadium/services/launch-darkly";
import {
  workspaceDefaultLoginFlag,
} from "@stadium/services/launch-darkly/constants";
import { CREATE_NEW_WORKSPACE_ROUTE } from "@stadium/constants/routes";

import styles from "./main.module.scss";

const UnAuthenticatedRightSection = ({
  className = "",
  loginOptions = {},
  isButtonWrapped,
  isWeglotDropDown = true,
  isMarketingPage = false,
}) => {
  const { [workspaceDefaultLoginFlag]: workspaceDefaultLoginFlagEnabled } = useFlags();
  const modifiedLoginOptions = useMemo(() => omit(loginOptions, "signUp"), [loginOptions]);
  const modifiedSignUpOptions = useMemo(
    () => ({
      ...loginOptions,
      signUp: true,
      ...(workspaceDefaultLoginFlagEnabled && { returnTo: CREATE_NEW_WORKSPACE_ROUTE }),
    }),
    [loginOptions],
  );

  const unAuthenticatedRightSectionContent = (
    <>
      <div
        className={classNames({
          [styles.authLoginHolder]: isWeglotDropDown,
          [styles.marketingAuthLoginHolder]: !isWeglotDropDown,
          [styles.authLoginHolderResponsive]: isMarketingPage,
        })}
      >
        <AuthLogin
          className={!isWeglotDropDown ? styles.marketingAuthLogin : styles.authLogin}
          loginOptions={modifiedLoginOptions}
          isButtonWrapped={isButtonWrapped}
        >
          <div className={`${styles.newLoginText} ${className}`}>LOG IN</div>
        </AuthLogin>
        <span className={styles.hideResponsive}> / </span>
        <AuthLogin
          className={!isWeglotDropDown ? styles.marketingAuthLogin : styles.authLogin}
          loginOptions={modifiedSignUpOptions}
          isButtonWrapped={isButtonWrapped}
        >
          <div className={`${styles.newLoginText} ${className}`}>SIGN UP</div>
        </AuthLogin>
      </div>
      <SpeakWithAnExpertCta
        isWeglotDropDown={isWeglotDropDown}
        className={`${isMarketingPage ? styles.speakExpertCtaResponsive : ""}`}
      />
    </>
  );

  return isMarketingPage ? (
    <div className={styles.marketingHeaderRightSection}>{unAuthenticatedRightSectionContent}</div>
  ) : (
    unAuthenticatedRightSectionContent
  );
};

export default withSyncFeatureFlag(UnAuthenticatedRightSection);
